export const environment = {
    production: false,
    baseUrl: 'https://ordsppc.open.com.ar/ords/ppcdr/'
  };
